import React, { useEffect, useState } from "react";
import FormLogin from "./FormLogin";
import SendRecoverPasswordForm from "./SendRecoverPasswordForm";
import "./Login.scss";
import Loader from "./Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Login = ({
  isOpen,
  error,
  onClose,
  sendFormLogin,
  sendRecoverPasswordForm,
  loginAttempt,
  resetLoginAttempt,
  resentValidation,
  localConfigurator,
  sendRecoverPasswordFormIsLoading,
  loginAttempts,
  loginErrorCode,
  resetLoginError,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const showRecoverPassword = location.hash === "#recover-password";
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    resetLoginAttempt();
  }, [isOpen, resetLoginAttempt]);

  useEffect(() => {
    if (
      !isOpen ||
      error ||
      loginErrorCode ||
      loginAttempts !== null ||
      loginAttempt?.isVerified === false
    ) {
      setIsLoading(false);
    }
  }, [error, isOpen, loginAttempt, loginAttempts, loginErrorCode]);

  const handleSendFormLogin = (values) => {
    setIsLoading(true);
    sendFormLogin(values);
  };

  return isOpen ? (
    <>
      <div className="modal-container">
        <Loader
          component="Login"
          isActive={
            isLoading === true || sendRecoverPasswordFormIsLoading === true
          }
        />
        <div className="background" onClick={() => onClose()} />
        <div className="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
          <div className="card border-grey border-lighten-3 m-0">
            <div className="card-header border-0">
              <h6 className="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
                <span>
                  {!showRecoverPassword
                    ? "Connexion"
                    : "Réinitialiser le mot de passe"}
                </span>
              </h6>
            </div>
            <div className="card-content">
              <div className="card-body">
                {!localConfigurator.auth ||
                (localConfigurator.auth &&
                  localConfigurator.auth.find(
                    (o) => o.strategy === "local",
                  )) ? (
                  !showRecoverPassword ? (
                    <FormLogin
                      error={error}
                      sendFormLogin={handleSendFormLogin}
                      localConfigurator={localConfigurator}
                      loginAttempt={loginAttempt}
                      resentValidation={resentValidation}
                      loginErrorCode={loginErrorCode}
                      loginAttempts={loginAttempts}
                      resetLoginError={resetLoginError}
                    />
                  ) : (
                    <SendRecoverPasswordForm
                      sendRecoverPasswordForm={sendRecoverPasswordForm}
                    />
                  )
                ) : (
                  <></>
                )}
                {!showRecoverPassword &&
                (!localConfigurator.auth ||
                  (localConfigurator.auth &&
                    localConfigurator.auth.find(
                      (o) => o.strategy === "local",
                    ))) ? (
                  <button
                    type="button"
                    onClick={() => navigate("/login#recover-password")}
                    className="btn btn-outline-secondary btn-sm"
                  >
                    Mot de passe oublié
                  </button>
                ) : (
                  localConfigurator.auth &&
                  localConfigurator.auth.find(
                    (o) => o.strategy === "local",
                  ) && (
                    <button
                      type="button"
                      onClick={() => navigate("/login")}
                      className="btn btn-outline-secondary btn-sm"
                    >
                      Se connecter
                    </button>
                  )
                )}

                {!showRecoverPassword &&
                  localConfigurator?.security?.allowRegister === true && (
                    <div className="text-right mt-2">
                      <Link to="/register">
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                        >
                          S'inscrire
                        </button>
                      </Link>
                    </div>
                  )}
              </div>
            </div>

            {localConfigurator.auth &&
              localConfigurator.auth.find((o) => o.strategy === "saml") && (
                <div className="card-footer">
                  <div className="float-sm-left text-center m-0">
                    <a
                      className="nav-link nav-menu-main btn btn-outline-primary"
                      href={
                        localConfigurator.auth.find(
                          (o) => o.strategy === "saml",
                        ).loginUrl
                      }
                    >
                      {
                        localConfigurator.auth.find(
                          (o) => o.strategy === "saml",
                        ).label
                      }{" "}
                    </a>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default Login;
